import { render, staticRenderFns } from "./ActiveSurveysTab.vue?vue&type=template&id=51bc67f9&scoped=true&"
import script from "./ActiveSurveysTab.vue?vue&type=script&lang=js&"
export * from "./ActiveSurveysTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc67f9",
  null
  
)

export default component.exports